import { Injectable } from '@angular/core';
import { FileData } from '../../models/fileData.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDataService {

  constructor() { }

  public fileDataMap: Map<string, FileData[]> = new Map();
  private fileDataSubject = new BehaviorSubject<Map<string, FileData[]>>(this.fileDataMap);
  fileData$ = this.fileDataSubject.asObservable();

  addFile(componentId: string, dataGroupId: string, file: FileData | FileData[]): void {
    var searchFileId = dataGroupId + '_' + componentId;
    const files = this.fileDataMap.get(searchFileId) || [];

    if (Array.isArray(file)) {
      files.push(...file);
    } else {
      files.push(file);
    }
    this.fileDataMap.set(searchFileId, files);
    this.notifyChanges();
  }

  getFiles(componentId: string, dataGroupId: string): FileData[] {
    var searchFileId = dataGroupId + '_' + componentId;
    return this.fileDataMap.get(searchFileId) || [];
  }

  removeFile(componentId: string, dataGroupId: string, file: FileData): void {
    var searchFileId = dataGroupId + '_' + componentId;
    const files = this.fileDataMap.get(searchFileId);
    if (files) {
      this.fileDataMap.set(
        searchFileId,
        files.filter(f => (file.azureFileName && file.azureFileName.length > 0 && f.azureFileName !== file.azureFileName)
        || (file.identifier && file.identifier.length > 0 && f.identifier !== file.identifier))
      );
      this.notifyChanges();
    }
  }

  public notifyChanges(): void {
    // Atualiza os observadores com o novo estado do mapa
    this.fileDataSubject.next(new Map(this.fileDataMap));
  }
}
